__turbopack_context__.v({
  "blok-big-title": "TagCloudBlok-module__5Pwc7q__blok-big-title",
  "blok-subtitle": "TagCloudBlok-module__5Pwc7q__blok-subtitle",
  "blok-title": "TagCloudBlok-module__5Pwc7q__blok-title",
  "image-placeholder": "TagCloudBlok-module__5Pwc7q__image-placeholder",
  "root": "TagCloudBlok-module__5Pwc7q__root",
  "wrapper": "TagCloudBlok-module__5Pwc7q__wrapper",
});
